import PurchaseDetailsModal from './PurchaseDetailsModal';

export default PurchaseDetailsModal;
